




import Vue, { PropType } from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";

Vue.component("vue-qrcode", VueQrcode);

export interface QrcodeProps {
  Url: string;
}

export default Vue.extend({
  name: "vc-qr-code",
  props: {
    Url: {
      type: String as PropType<QrcodeProps["Url"]>,
      default: ""
    }
  }
});
